import type { ReactNode } from 'react';
import { SessionAuth, useSessionContext } from 'supertokens-auth-react/recipe/session';
import { UserRoleClaim } from 'supertokens-auth-react/recipe/userroles';

// No MUI usage here to begin with -- this is a rename-and-type-it pass only.
// SuperTokens' UserRoleClaim validator logic is unchanged, per Phase 5
// instructions.
export default function AdminRoute(props: { children?: ReactNode }) {
    return (
        <SessionAuth
            overrideGlobalClaimValidators={(globalValidators) => [
                ...globalValidators,
                UserRoleClaim.validators.includes('admin')
                /* PermissionClaim.validators.includes("modify") */
            ]}>
            <InvalidClaimHandler>{props.children}</InvalidClaimHandler>
        </SessionAuth>
    );
}

function InvalidClaimHandler(props: { children?: ReactNode }) {
    const sessionContext = useSessionContext();
    if (sessionContext.loading) {
        return null;
    }

    if (sessionContext.invalidClaims.some((i) => i.id === UserRoleClaim.id)) {
        return <div>You cannot access this page because you are not an admin.</div>;
    }

    // We show the protected route since all claims validators have
    // passed implying that the user is an admin.
    return <div>{props.children}</div>;
}

export function useCurrentUser() {
    const sessionContext = useSessionContext();
    if (sessionContext.loading) {
        return null;
    }
    return sessionContext;
}
